import {NavLink} from "react-router-dom";

export const CustomerLink = (
    {
        customer,
        customerName,
        customerEmail
    }: {
        customer: string,
        customerName: string, customerEmail: string
    }) => {

    return <NavLink to={`/customers/${customer}`}>{customerName} [ {customerEmail} ]</NavLink>

}